import { c as _c } from "react/compiler-runtime";
import { LayoutFAQs } from "@/components/terra/layouts/LayoutFAQs/LayoutFAQs";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createRichTextOptions } from "@/lib/formatters/formatRichText";
import { resolveHyperlinkLinks } from "@/lib/formatters/richTextLinks";
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale";
import { handleButtons } from "@/lib/utils";
export default async function MXPEmbeddedInfoList(props) {
  const $ = _c(5);
  const {
    value,
    lang: t0
  } = props;
  const lang = t0 === undefined ? DEFAULT_PUBLIC_LANG : t0;
  let t1;
  if ($[0] !== lang || $[1] !== value.itemsCollection?.items) {
    const items = (value.itemsCollection?.items ?? []).filter(Boolean);
    const links = await resolveHyperlinkLinks(items.map(_temp), lang);
    const richTextOptions = createRichTextOptions(lang, links);
    t1 = items.map(item_0 => {
      const buttonData = handleButtons([item_0.ctaLink], false, lang);
      return {
        headline: item_0.headline,
        description: item_0.description?.json ? documentToReactComponents(item_0.description.json, richTextOptions) : "",
        ctaLink: buttonData?.[0]
      };
    });
    $[0] = lang;
    $[1] = value.itemsCollection?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const faqItems = t1;
  let t2;
  if ($[3] !== faqItems) {
    t2 = <LayoutFAQs faqItems={faqItems} faqType="t2-collapsed" isWrapped={false} isEmbedded={true} />;
    $[3] = faqItems;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp(item) {
  return item.description;
}